function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.71048 5.28748C7.41297 6.27768 6.26944 7.45283 5.31683 8.77498L7.12678 10.125C7.9576 8.97908 8.94787 7.95637 10.0679 7.08748L8.71048 5.28748Z",
  fill: "#F5F5F5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.20371 13.8375L3.0544 13.1625C2.50798 14.7165 2.23997 16.3538 2.26255 18H4.52498C4.52039 16.5849 4.74969 15.1786 5.20371 13.8375Z",
  fill: "#F5F5F5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M3.05441 22.95C3.57903 24.5188 4.34201 25.9984 5.31684 27.3375L7.12679 25.9875C6.30901 24.8488 5.66127 23.5983 5.20372 22.275L3.05441 22.95Z",
  fill: "#F5F5F5"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M8.82336 30.7125C10.1699 31.682 11.6577 32.4407 13.2351 32.9625L13.9138 30.825C12.5832 30.3699 11.3259 29.7258 10.1808 28.9125L8.82336 30.7125Z",
  fill: "#F5F5F5"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M13.2354 3.03747L13.9141 5.17497C15.2626 4.72344 16.6766 4.4954 18.0996 4.49997V2.24997C16.4443 2.22751 14.798 2.49405 13.2354 3.03747Z",
  fill: "#F5F5F5"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3754 30.7125C28.7079 29.7249 29.8891 28.5501 30.8822 27.225L29.0722 25.875C28.231 27.0493 27.1987 28.0759 26.0179 28.9125L27.3754 30.7125Z",
  fill: "#F5F5F5"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M30.9952 22.1625L33.1445 22.8375C33.6366 21.2702 33.9032 19.6416 33.9364 18H31.674C31.6786 19.4151 31.4493 20.8214 30.9952 22.1625Z",
  fill: "#F5F5F5"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M33.0315 13.05C32.5069 11.4812 31.7439 10.0016 30.7691 8.66248L28.9592 10.0125C29.7769 11.1512 30.4247 12.4017 30.8822 13.725L33.0315 13.05Z",
  fill: "#F5F5F5"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2623 5.17505C25.9158 4.20557 24.428 3.44678 22.8506 2.92505L22.1719 5.06255C23.5025 5.51758 24.7599 6.16176 25.9049 6.97505L27.2623 5.17505Z",
  fill: "#F5F5F5"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M22.9637 32.9624L22.285 30.825C20.9364 31.2765 19.5224 31.5045 18.0995 31.5V33.75C19.7436 33.6525 21.3734 33.3887 22.9637 32.9624Z",
  fill: "#F5F5F5"
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 18.0994,
  cy: 18,
  rx: 6.03315,
  ry: 6,
  fill: "#F5F5F5"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0995 9L20.7119 13.5H15.487L18.0995 9Z",
  fill: "#F5F5F5"
});

function SvgSaturation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaturation);
export default __webpack_public_path__ + "static/media/Saturation.a3fedc9f.svg";
export { ForwardRef as ReactComponent };